import { jsx } from 'react/jsx-runtime';
import { PageLayout } from '../PageLayout/PageLayout.js';

const Root = props => {
  return /*#__PURE__*/jsx(PageLayout, {
    containerWidth: "full",
    padding: "none",
    columnGap: "none",
    rowGap: "none",
    _slotsConfig: {
      header: Header,
      footer: Footer
    },
    ...props
  });
};
Root.displayName = "Root";
Root.displayName = 'SplitPageLayout';

// ----------------------------------------------------------------------------
// SplitPageLayout.Header

const Header = ({
  padding = 'normal',
  divider = 'line',
  ...props
}) => {
  // eslint-disable-next-line primer-react/direct-slot-children
  return /*#__PURE__*/jsx(PageLayout.Header, {
    padding: padding,
    divider: divider,
    ...props
  });
};
Header.displayName = "Header";
Header.displayName = 'SplitPageLayout.Header';

// ----------------------------------------------------------------------------
// SplitPageLayout.Content

const Content = ({
  width = 'large',
  padding = 'normal',
  ...props
}) => {
  return /*#__PURE__*/jsx(PageLayout.Content, {
    width: width,
    padding: padding,
    ...props
  });
};
Content.displayName = "Content";
Content.displayName = 'SplitPageLayout.Content';

// ----------------------------------------------------------------------------
// SplitPageLayout.Pane

const Pane = ({
  position = 'start',
  sticky = true,
  padding = 'normal',
  divider = 'line',
  ...props
}) => {
  return /*#__PURE__*/jsx(PageLayout.Pane, {
    position: position,
    sticky: sticky,
    padding: padding,
    divider: divider,
    ...props
  });
};
Pane.displayName = "Pane";
Pane.displayName = 'SplitPageLayout.Pane';

// ----------------------------------------------------------------------------
// SplitPageLayout.Footer

const Footer = ({
  padding = 'normal',
  divider = 'line',
  ...props
}) => {
  // eslint-disable-next-line primer-react/direct-slot-children
  return /*#__PURE__*/jsx(PageLayout.Footer, {
    padding: padding,
    divider: divider,
    ...props
  });
};
Footer.displayName = "Footer";
Footer.displayName = 'SplitPageLayout.Footer';

// ----------------------------------------------------------------------------
// Export

const SplitPageLayout = Object.assign(Root, {
  Header,
  Content,
  Pane,
  Footer
});

export { Content, Footer, Header, Pane, Root, SplitPageLayout };
